// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".allowance-modal[data-v-453ce1f7]{position:relative;margin-top:20vh}.allowance-modal .close-icon[data-v-453ce1f7]{position:absolute;right:8px;top:8px;cursor:pointer}.allowance-modal .transfer-code-instructions[data-v-453ce1f7]{max-width:370px}.allowance-modal .v-messages.error--text[data-v-453ce1f7]{color:#e37d7d!important}", ""]);
// Exports
module.exports = exports;
